import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useDeleteGameMutation, useGetGameByIdQuery, useRequestJoinMutation, useUnJoinMutation, } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { convertGameToViewModel } from "../common/mappers/convertToViewModel";
import { GameDetails } from "./components/GameDetails";
export var GameDetailsPage = function () {
    var gameId = useParams().gameId;
    var navigate = useNavigate();
    var _a = useRequestJoinMutation(), reguestJoinAction = _a[0], reguestJoinState = _a[1];
    var _b = useUnJoinMutation(), unJoinAction = _b[0], unJoinState = _b[1];
    var gameGetState = useGetGameByIdQuery({ id: gameId });
    var _c = useDeleteGameMutation(), gameDeleteAction = _c[0], gameDeleteState = _c[1];
    var editClickHandler = function () {
        navigate(RoutesList.Game.getGameEdit(gameId));
    };
    var deleteClickHandler = function () {
        gameDeleteAction({ id: gameId });
    };
    var requestJoinHandler = function () {
        reguestJoinAction({ id: gameId });
    };
    var unJoinHandler = function () {
        unJoinAction({ id: gameId });
    };
    useEffect(function () {
        if (gameDeleteState.isSuccess) {
            navigate(RoutesList.Game.getGamesList());
        }
    }, [gameDeleteState.isSuccess]);
    useSetPageData({ title: "Игра" });
    var isLoading = gameGetState.isLoading ||
        gameDeleteState.isLoading ||
        reguestJoinState.isLoading ||
        unJoinState.isLoading;
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: isLoading, loadingKey: "gameDetails" }), gameGetState.isSuccess && (_jsx(GameDetails, { data: convertGameToViewModel(gameGetState.data), onEditClick: editClickHandler, onDeleteClick: deleteClickHandler, onJoinClick: requestJoinHandler, onUnJoinClick: unJoinHandler }))] }));
};
